/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Support_Internalquestions_Body_11Inputs */

const en_settings_support_internalquestions_body_11 = /** @type {(inputs: Settings_Support_Internalquestions_Body_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for help`)
};

/**
* | output |
* | --- |
* | "for help" |
*
* @param {Settings_Support_Internalquestions_Body_11Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_support_internalquestions_body_11 = /** @type {((inputs?: Settings_Support_Internalquestions_Body_11Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Internalquestions_Body_11Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_support_internalquestions_body_11(inputs)
});
export { settings_support_internalquestions_body_11 as "settings_support_internalQuestions_body_1" }